module.exports = __webpack_public_path__ + "static/media/P1050669-min.08296ac0.JPG";